import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-file-upload-loading',
    templateUrl: './dialog-file-upload-loading.component.html',
    styleUrls: ['./dialog-file-upload-loading.component.css'],
    standalone: false
})
export class DialogFileUploadLoadingComponent {
    constructor(
        public dialogRef: MatDialogRef<DialogFileUploadLoadingComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) { }
}
